import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-396a3f2d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "dialog-header" }
const _hoisted_2 = { class: "header-left" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "accent-bar" }, null, -1))
const _hoisted_4 = { class: "header-title" }
const _hoisted_5 = { class: "header-right" }
const _hoisted_6 = { class: "refresh-time" }
const _hoisted_7 = {
  key: 0,
  class: "tips"
}
const _hoisted_8 = { class: "dialog-footer" }

import { ref, computed, watch } from 'vue'
import { Refresh } from '@element-plus/icons-vue'
import AccountTabContent from './AccountTabContent.vue'
import { useAccountDetail } from './hooks/useAccountDetail'


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props, { expose }) {

const visible = ref(false)
const clientId = ref('')
const title = ref('')

const topTabs = [
  { label: '证券', name: 'stock' },
  { label: '基金', name: 'fund' },
  { label: '债券', name: 'bond' },
  { label: '结构化票据', name: 'sps' },
  { label: '其他', name: 'extra' },
  { label: '现金', name: 'cash' }
]

const subTabsMap: Record<string, { label: string, name: string }[]> = {

  fund: [
    { label: '港元', name: 'HKD' },
    { label: '美元', name: 'USD' }
  ],
  bond: [
    { label: '港元', name: 'bondHKD' },
    { label: '美元', name: 'bondUSD' }
  ],
  sps: [
    { label: '港元', name: 'HKD' },
    { label: '美元', name: 'USD' },
    { label: '其他币种', name: 'OTHER_HKD' }
  ],
  extra: [
    { label: '港元', name: 'HKD' },
    { label: '美元', name: 'USD' },
    { label: '其他币种', name: 'OTHER_HKD' }
  ],
  cash: [
    { label: '港元', name: 'HK' },
    { label: '美元', name: 'US' },
    { label: '人民币', name: 'A' }
  ]
}

const activeTopTab = ref('stock')
const activeSubTab = ref('HK')
const activeOtherCurrency = ref('HKD')

const currentSubTabs = computed(() => {
  if (activeTopTab.value === 'stock') {
    return visibleStockSubTabs.value
  }
  return subTabsMap[activeTopTab.value] || []
})

const isCashTab = computed(() => activeTopTab.value === 'cash')
const isStockTab = computed(() => activeTopTab.value === 'stock')
const showTips = computed(() => !isStockTab.value && !isCashTab.value)

const tipsProductMap: Record<string, string> = {
  fund: '基金',
  bond: '债券',
  sps: '结构化产品'
}
const tipsProduct = computed(() => tipsProductMap[activeTopTab.value] ?? '')

const {
  loading,
  currentCards,
  currentColumns,
  currentTableData,
  visibleStockSubTabs,
  refreshTime,
  refresh
} = useAccountDetail({
  clientId,
  activeTopTab,
  activeSubTab,
  activeOtherCurrency
})

// 切换顶层 tab 时，重置子 tab 为第一个
watch(activeTopTab, (val) => {
  const tabs = val === 'stock' ? visibleStockSubTabs.value : subTabsMap[val] || []
  activeSubTab.value = tabs[0]?.name || ''
})

const onSubTabChange = (name: string) => {
  activeSubTab.value = name
}

const onOtherCurrencyChange = (currency: string) => {
  activeOtherCurrency.value = currency
}

const onConfirm = () => {
  visible.value = false
}

const open = (id: string, name: string) => {
  clientId.value = id
  title.value = name
  activeTopTab.value = 'stock'
  activeSubTab.value = 'HK'
  activeOtherCurrency.value = 'HKD'
  visible.value = true
  refresh()
}

const close = () => {
  visible.value = false
}

expose({ open, close })

return (_ctx: any,_cache: any) => {
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_el_tabs = _resolveComponent("el-tabs")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    modelValue: visible.value,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((visible).value = $event)),
    width: "988px",
    "show-close": false,
    "close-on-click-modal": false,
    "close-on-press-escape": false,
    "destroy-on-close": "",
    "custom-class": "check-detail-dialog"
  }, {
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_8, [
        _createVNode(_component_el_button, {
          class: "confirm-btn",
          type: "primary",
          onClick: onConfirm
        }, {
          default: _withCtx(() => [
            _createTextVNode(" 确定 ")
          ]),
          _: 1
        })
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("span", _hoisted_4, _toDisplayString(title.value) + "的账户", 1)
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("span", _hoisted_6, "实时更新：" + _toDisplayString(_unref(refreshTime)), 1),
          _createVNode(_component_el_icon, {
            class: "refresh-icon",
            onClick: _unref(refresh)
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(Refresh))
            ]),
            _: 1
          }, 8, ["onClick"])
        ])
      ]),
      _createVNode(_component_el_tabs, {
        modelValue: activeTopTab.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((activeTopTab).value = $event)),
        class: "top-tabs"
      }, {
        default: _withCtx(() => [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(topTabs, (tab) => {
            return _createVNode(_component_el_tab_pane, {
              key: tab.name,
              label: tab.label,
              name: tab.name
            }, null, 8, ["label", "name"])
          }), 64))
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(AccountTabContent, {
        "active-top-tab": activeTopTab.value,
        "sub-tabs": _unref(currentSubTabs),
        cards: _unref(currentCards),
        columns: _unref(currentColumns),
        "table-data": _unref(currentTableData),
        loading: _unref(loading),
        "default-sub-tab": activeSubTab.value,
        "hide-position": _unref(isCashTab),
        onSubTabChange: onSubTabChange,
        onOtherCurrencyChange: onOtherCurrencyChange
      }, null, 8, ["active-top-tab", "sub-tabs", "cards", "columns", "table-data", "loading", "default-sub-tab", "hide-position"]),
      (_unref(showTips))
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, "注：如阁下需交易" + _toDisplayString(_unref(tipsProduct)) + "，请致电+852 2153 3366，与我们联络。", 1))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})